export default function(address) {
	return `${address.city}-${address.zip_code}-${address.street}-${address.house_number}-${address.house_number_extension}`.replace(
		/ /g,
		''
	);
}
